<div class="entity-management-container">
  <div *ngIf="loading" class="loading-overlay">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>

  <div class="entity-table-wrapper">
    <!-- Header Bar -->
    <div class="entity-header-bar" *ngIf="data?.header">
      <div class="header-left">
        <!-- Dropdowns -->
        <ng-container *ngFor="let dropdown of data.header.dropdowns">
          <div class="header-dropdown">
            <label>{{ dropdown.label }}</label>
            <mat-form-field appearance="outline" class="material-dropdown">
              <mat-select [value]="dropdown.defaultValue" (selectionChange)="onDropdownSelectionChange(dropdown.key, $event.value)">
                <mat-option *ngFor="let option of dropdown.options" [value]="option">
                  {{ option }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </ng-container>
      </div>

      <div class="header-center">
        <!-- Tab Buttons -->
        <ng-container *ngFor="let component of data.header.components">
          <button 
            *ngIf="component.type === 'button'"
            class="tab-button {{ component.style }}" 
            [class.active]="component.isActive"
            (click)="handleTabAction(component.actionId)">
            {{ component.label }}
          </button>
        </ng-container>
      </div>

      <div class="header-right">
        <!-- Action Icons -->
        <ng-container *ngFor="let action of data.header.actions">
          <button class="header-icon" mat-icon-button (click)="handleHeaderAction(action.actionId)" [matTooltip]="action.tooltip">
            <mat-icon>{{ action.icon }}</mat-icon>
          </button>
        </ng-container>
      </div>
    </div>

    <!-- Table Container -->
    <div class="table-container">
      <div class="table-body">
        <!-- Fixed header table -->
        <div class="fixed-header" #headerScroll (scroll)="onHeaderScroll($event)" (mousedown)="onHeaderMouseDown($event)">
          <table class="header-table">
            <thead>
              <tr>
                <th *ngIf="showEditColumn" class="edit-col" [style.width.px]="40"></th>
                <th class="checkbox-col" [style.width.px]="columnWidths[0]">
                  <mat-checkbox [checked]="allSelected" (change)="toggleAllSelection()"></mat-checkbox>
                </th>
                <th *ngFor="let col of data.columns; let i = index" [style.width.px]="columnWidths[i + 1]" [class.sortable]="col.sortable">
                  <div class="header-content">
                    <span>{{ col.label }}</span>
                    <mat-icon *ngIf="col.sortable">{{ getSortIcon(col.key) }}</mat-icon>
                  </div>
                  <div class="resizer" (mousedown)="onResizeStart($event, i + 1)"></div>
                </th>
              </tr>
            </thead>
          </table>
        </div>

        <!-- Scrollable body table (keeps columns widths from header) -->
        <div class="scrollable-body" #bodyScroll (scroll)="onBodyScroll($event)">
          <table class="body-table">
            <tbody>
              <ng-container *ngIf="!loading">
                <tr *ngFor="let record of records" (click)="selectRecord(record)" [class.selected]="record === selectedRecord">
                  <td *ngIf="showEditColumn" class="edit-col" [style.width.px]="40">
                    <button mat-icon-button class="row-edit" (click)="openEdit(record, $event)" matTooltip="Edit">
                      <mat-icon>edit</mat-icon>
                    </button>
                  </td>
                  <td class="checkbox-col" [style.width.px]="columnWidths[0]">
                    <mat-checkbox [checked]="selection.has(record)" (change)="toggleSelection(record)"></mat-checkbox>
                  </td>
                  <td *ngFor="let col of data.columns; let i = index" [style.width.px]="columnWidths[i + 1]">{{ record[col.key] }}</td>
                </tr>
              </ng-container>
            </tbody>
          </table>

          <div *ngIf="!loading && records.length === 0" class="no-records">
            No records found.
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="entity-footer-bar" *ngIf="data?.pagination?.enabled">
      <button mat-button (click)="prevPage()" [disabled]="pageIndex===0">Prev</button>
      <span>Page: {{ pageIndex + 1 }}</span>
      <button mat-button (click)="nextPage()" [disabled]="records.length < pageSize">Next</button>
      <span style="margin-left:12px">Showing: {{ records.length }} rows</span>
    </div>
  </div>
</div>